// extracted by mini-css-extract-plugin
export default {"gridWrapper":"ProfileArchivePage_gridWrapper__v0ArW","loaderWrapper":"ProfileArchivePage_loaderWrapper__hKThu","loader":"ProfileArchivePage_loader__I2HaT"};